import { Component, Input, OnInit } from '@angular/core';
import { NewVulnerabilityService } from '../Data Service/new-vulnerability.service';
import { newVulClass } from '../Data Service/newVulClass';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, FormsModule, Validators} from '@angular/forms'
import { NgForm } from '@angular/forms';
import {ActivatedRoute,Router,Params} from '@angular/router';
import { HomeGridComponent } from '../home/home-grid/home-grid.component';
import { AppComponent } from '../app.component';
import { IUrl } from './IUrl';
import { CUrl } from './CUrl';

@Component({
  selector: 'app-new-vulnerability',
  templateUrl: './new-vulnerability.component.html',
  styleUrls: ['./new-vulnerability.component.css']
})
export class NewVulnerabilityComponent implements OnInit {

  @Input() vulData : any;
  DateRaised : any;
  Org : string;
  CVE: string;
  Description: string;
  Title: string;
  CorrectiveAction: string;
  Vref : any;
  SaveButtonValue : any;
 
  VulnerabilityList : any=[];

  objVulclass = new newVulClass();
  data: any[];
   DDdata: any;
   public errormessage: string = '';

   productForm: UntypedFormGroup;
   
  constructor(private fb:UntypedFormBuilder,private service : NewVulnerabilityService,private _route : ActivatedRoute
    ,private _router : Router,private _app : AppComponent) {
      this._route.params.subscribe(params => {
        this.paramsChange(params.id);
    });

    this.productForm = this.fb.group({
      quantities: this.fb.array([this.newQuantity()]) ,
    });
    
    }

    paramsChange(id:any) {      
      this.objVulclass = new newVulClass();
    }

  ngOnInit(): void {
    // this.refreshNewVulnerabilityList()
    this.getNewVulDD();    
      let gccID = this._route.snapshot.params.id;     
      if(gccID !=0){
        this.getVuDataByID(gccID);
      }
      //this.productForm.controls['dataurl'].setValidators([Validators.pattern('/^(http[s]?://){0,1}(www.){0,1}[a-zA-Z0-9.-]+.[a-zA-Z]{2,5}[.]{0,1}/')])
  }

  SetQtyValue(qtySet : IUrl[]): UntypedFormArray{
    const formmarray = new UntypedFormArray([]);
    qtySet.forEach(s => {
      formmarray.push(this.fb.group({
        dataurl : s.URLList
      }));
    });    
    return formmarray;
  }

  quantities() : UntypedFormArray {
    return this.productForm.get("quantities") as UntypedFormArray
  }

  newQuantity(): UntypedFormGroup {
    return this.fb.group({
      dataurl : ['']
      //dataurl : this.fb.array([this.urls]) ,Validators.pattern('/^[a-zA-Z]+$/') ,[Validators.required],Validators.pattern('/^(http[s]?://){0,1}(www.){0,1}[a-zA-Z0-9.-]+.[a-zA-Z]{2,5}[.]{0,1}/')
    })
  }

  get urls(): UntypedFormGroup{
    return this.fb.group({
      dataurl : ['']
    })
   }

   addQuantity() {
    this.quantities().push(this.newQuantity());
  }
   
  removeQuantity(i:number) {
    this.quantities().removeAt(i);
  }

  getVuDataByID(gccID : any){
    this.service.getNewVulnerabilityList(gccID).subscribe(
      (data : any)=>{        
        this.objVulclass.VRef = gccID;        
        this.objVulclass = data[0];
        this.productForm.setControl("quantities", this.SetQtyValue(data[0].URLList));        
      }, (error:any) => {        
        this.errormessage = error;
      }
    )    
  }

  getNewVulDD(){
    this.service.getNewVulDropDownData().subscribe((data : any)=>{      
      this.DDdata = data;        
    }, (error:any) => {
        this.errormessage = error;
    })
  }

  resetForm(form : NgForm){
  form.form.reset();
  this.service.formData=new newVulClass();
  }

  onSubmit(){    
    this.SaveButtonValue = "No";
    let vUrl : Array<IUrl> = [];
    this.objVulclass.LastUpdatedBy = localStorage.getItem('UserID').substring(0,localStorage.getItem('UserID').lastIndexOf("@"));
    //  this.objVulclass.LastUpdatedBy = "sharad.singh.singh";
    if(this.validate(this.objVulclass)){ 
      this.addVulnerability(this.objVulclass);
    }
    
  }

  onPublish(){    
    this.SaveButtonValue = "Yes";
    if(this.validate(this.objVulclass)){
    this.addVulnerability(this.objVulclass);
    }     
      // this.reloadComponent();
     //this._home.reloadCurrentRoute();
  }
  
  
reloadComponent() {
  let currentUrl = this._router.url;  
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      this._router.navigate(['/home']);
  }

  reloadCurrentRoute() {
    let currentUrl = this._router.url;    
    this._router.navigateByUrl('/Refresh', {skipLocationChange: false}).then(() => {
       this._router.navigate(['/home']);
    });
}

  addVulnerability(oVul : newVulClass){    
    //this.vulData = {DateRaised:null,Org:"",CVE:"",Desc:"",Title:"",CorrectiveAction:"",Vref:0};    
    let arrURL : Array<CUrl> = [];
    for(let j=0; j < this.productForm.controls["quantities"].value.length ; j++){
      var valURL = new CUrl();
      valURL.URLList = this.productForm.controls["quantities"].value[j].dataurl;
      arrURL.push(valURL)
    }
    var val  = {DateRaised:oVul.DateRaised,
                Org : oVul.Org,
                CVE : oVul.CVE,
                Description : oVul.Description,
                Title : oVul.Title,
                CorrectiveAction : oVul.CorrectiveAction,
                VRef : oVul.VRef,
                Publish : this.SaveButtonValue,
                LastUpdatedBy : oVul.LastUpdatedBy,
                URLList : arrURL
              };              
              if(val.CVE=="" || val.CVE == null){
                alert("Please fill the mandatory fields");
              }
             else{
              if(val.VRef == null){                
               this.service.addVulnerability(val).subscribe(res => {
                 //this.resetForm();
                  alert(res.toString());
                  // console.log("calling refresh list");
                  // this.service.refreshListData();
                  // console.log("routing home");
                  // this._router.navigated = false;
                  //this._router.navigated = false;
                  //this._app._refreshNeeded = true;
                  if(res.toString() == "Added Successfully"){
                    this._router.navigate(['/home']);
                  }
                   
              }, (error:any) => {
                this.errormessage = error;
            });
              }
              else{
                this.service.updateVulnerabilityData(val).subscribe(res => {
                 alert(res.toString());
                //  console.log("calling refresh list");
                //  this.service.refreshListData();
                //  console.log("routing home");
                  //this._router.navigated = false;
                  //this._app._refreshNeeded = true;
                  //setTimeout(() => {
                    this._router.navigate(['/home']);
                  //}, 2000);
                  
               }, (error:any) => {
                this.errormessage = error;
            });
              }
               this._app._ngCallCount = 1;
             }

  }

  Cancel(){
    this._router.navigate(['/home']);
  }

  refreshNewVulnerabilityList(){
    this.service.getNewVulnerabilityList(this.DateRaised).subscribe(data => {
      this.VulnerabilityList = data;
      
    });
  }

  validate(oVul : newVulClass) : boolean {

    console.log("Testing something!")
    console.log(oVul)
    var valData  = {DateRaised:oVul.DateRaised,
      Org : oVul.Org,
      CVE : oVul.CVE,
      Description : oVul.Description,
      Title : oVul.Title,
      CorrectiveAction : oVul.CorrectiveAction
    };
    //var valUrl = this.productForm.controls["quantities"].value[0].dataurl;
    //|| valUrl == "" || valUrl == null
    let result : boolean;
    result = true;
    if(valData.CVE=="" || valData.CVE == null || valData.DateRaised =="" || valData.DateRaised == null || valData.Org == "" 
      || valData.Org == "Select" || valData.Org == null || valData.Description == "" || valData.Description == null
      || valData.CorrectiveAction == "" || valData.CorrectiveAction == null || valData.Title == "" || valData.Title == null
      )
    {
      result = false;
      alert("Please fill the mandatory fields!");
    }

    if(!this.URLReplacer(0)){
      result = false;
      alert("Please fill valid URL");
    }    
    return result;
  }

  URLReplacer(value: number){    
    var retval = value;
    //var vUrl = this.productForm.controls["quantities"].value[value].dataurl;
    var vUrl ;
    var urlreg=/(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/;

    let urlCompare : boolean;
    urlCompare = true;
    for(let j=0; j < this.productForm.controls["quantities"].value.length ; j++){
      vUrl = this.productForm.controls["quantities"].value[j].dataurl;
      if(vUrl != null && vUrl != undefined && vUrl != ""){
        urlCompare = urlreg.test(vUrl);
      }
      if(urlCompare == false)
      {
        break;
      }      
    }

    

    
    return urlCompare;
            // if(retval != null) {
            //     var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            //     retval = value.replace(urlRegex, function (url) {
            //         return '<a href="' + url + '" target="_blank">' + url + '</a>';
            //     });
            // }
            // document.getElementById("iCorAction").innerText="<a href="+retval+">"+retval+";</a>";
            // document.getElementById("iCorAction").style.backgroundColor= "#FF0000";
            //return retval;

    // let match = str.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
    // let final=str;
    // match.map(url=>{
    //     final=final.replace(url,"<a href=\""+url+"\" target=\"_BLANK\">"+url+"</a>")
    // })
    // return final;
  }

  OpenPopUpPage(value : number){    
    var vUrl = this.productForm.controls["quantities"].value[value].dataurl
    if(vUrl.startsWith("https://")){
      vUrl = vUrl.replace("https://","");
    }
    if((vUrl != null && vUrl != undefined && vUrl != "" && vUrl.length != 0))
    // (window as any).open(vUrl, "_blank");
    (window as any).open("https://"+vUrl, "_blank");
    // window.location.assign(value)
    //window.open(value, "_blank");
  }

  checkValidCVE(cveVal : any,vRef : any){
    var valData  = {
      VRef:(vRef== undefined) ? "": vRef,
      CVE : cveVal,
      Title : ""
    };

    this.service.chkValidCVETitle(valData).subscribe(
      (data : any)=>{        
        //this.objVulclass = data[0];
        if(data != "Ok"){
          alert(data);
        }
      }, (error:any) => {
        // console.log(error);
        this.errormessage = error;
      }
    )

  }

  checkValidTitle(vTtile : any,vRef : any){
  
    var valData  = {
      VRef:(vRef== undefined) ? "": vRef,
      CVE : "",
      Title : vTtile
    };

    this.service.chkValidCVETitle(valData).subscribe(
      (data : any)=>{        
        //this.objVulclass = data[0];
        if(data != "Ok"){
          alert(data);
        }
      }, (error:any) => {
        // console.log(error);
        this.errormessage = error;
      }
    )

  }
}
